import React, { CSSProperties, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dropdown,
  DropdownItem,
  getColor,
  Typography,
} from "fds";
import { useTranslation } from "react-i18next";
import useCheckboxGroup from "fds/src/hooks/useCheckboxGroup";
import { LogDTO } from "../../../types/log";
import { check } from "prettier";
import {
  FULL_FILTER_LOG_BY_TYPE,
  FULL_FILTER_LOG_BY_TYPE_RESOURCE,
  INIT_LOG_FILTER,
} from ".";
interface LogFilterCheckdownProps {
  classes?: string;
  style?: CSSProperties;
  buttonClick: number;
  filter: LogDTO;
  type:
    | "filterDocument"
    | "filterWorkgroup"
    | "filterWebMeeting"
    | "filterChat";
  changeFilterByKey: (key: string, val: any) => void;
  setButtonClick: (click: number) => void;
  changeDateFilter?: (newFilter: string) => void;
}
const LogFilterCheckdown: React.FC<LogFilterCheckdownProps> = ({
  buttonClick,
  filter,
  setButtonClick,
  changeFilterByKey,
  type,
  classes,
  style,
}) => {
  const { t } = useTranslation();
  const targetFullFilter =
    type === "filterWorkgroup"
      ? FULL_FILTER_LOG_BY_TYPE.filterWorkgroup
      : type === "filterDocument"
      ? FULL_FILTER_LOG_BY_TYPE.filterDocument
      : FULL_FILTER_LOG_BY_TYPE.filterWebMeeting;
  const title =
    type === "filterDocument"
      ? t("common.file")
      : type === "filterWorkgroup"
      ? t("common.workgroup")
      : type === "filterChat"
      ? t("common.chat")
      : t("common.meetings");

  const checkboxGroup = useCheckboxGroup<number>(targetFullFilter);
  useEffect(() => {
    const newFilter = JSON.parse(JSON.stringify(filter));
    delete newFilter[type];
    const isInit =
      newFilter.filterChat === undefined &&
      newFilter.filterDocument === undefined &&
      newFilter.filterWorkgroup === undefined &&
      newFilter.filterWebMeeting === undefined;
    checkboxGroup.handleAllClick([
      ...(filter[type] ?? (isInit ? targetFullFilter : [])),
    ]);
  }, [buttonClick]);
  const checkFilterInit = () => {
    return (
      filter["filterChat"] === undefined &&
      filter["filterDocument"] === undefined &&
      filter["filterWebMeeting"] === undefined &&
      filter["filterWorkgroup"] === undefined
    );
  };
  return (
    <Dropdown
      btnStyle="round"
      classes={"mg ml-12"}
      placeholder={title}
      buttonWidth={240}
      btnSize="rd"
      showValue
      value={
        !filter[type]
          ? undefined
          : type === "filterChat"
          ? filter[type]?.includes(0)
            ? t("common.allInclude")
            : t("common.allExclude")
          : filter[type]?.length + ""
      }
      buttonClick={buttonClick}
    >
      {type === "filterChat" ? (
        <Box direction="column">
          <DropdownItem
            label={t("common.allInclude")}
            checkColor={
              checkFilterInit() ||
              (!checkFilterInit() && filter.filterChat?.length === 1)
            }
            type="check"
            checked={
              checkFilterInit() ||
              (!checkFilterInit() && filter.filterChat?.length === 1)
            }
            onClick={() => {
              setButtonClick(buttonClick + 1);
              changeFilterByKey(type, [0]);
            }}
          />
          <DropdownItem
            label={t("common.allExclude")}
            checkColor={
              !(
                checkFilterInit() ||
                (!checkFilterInit() && filter.filterChat?.length === 1)
              )
            }
            type="check"
            checked={
              !(
                checkFilterInit() ||
                (!checkFilterInit() && filter.filterChat?.length === 1)
              )
            }
            onClick={() => {
              setButtonClick(buttonClick + 1);
              changeFilterByKey(type, []);
            }}
          />
        </Box>
      ) : (
        <Box minWidth={224} maxHeight={388} classes={"dropdown-checkbox"}>
          <Box
            height={26}
            width="100%"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              type="caption1_rg"
              classes="mg ml-8"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("common.type")}
            </Typography>
            <Button
              btnStyle="link"
              label={
                checkboxGroup.selected.length === targetFullFilter.length
                  ? t("common.unselectAll")
                  : t("common.selectAll")
              }
              onClick={() =>
                checkboxGroup.selected.length === targetFullFilter.length
                  ? checkboxGroup.handleAllClick([])
                  : checkboxGroup.handleAllClick([...targetFullFilter])
              }
              textColor={getColor("COLOR_TEXT_BRAND")}
            />
          </Box>
          <Box classes="mg mt-4 fav-workgroups">
            <Box direction="column" alignItems="flex-start">
              {targetFullFilter.map((index) => (
                <Checkbox
                  classDiv="logDropdown"
                  label={FULL_FILTER_LOG_BY_TYPE_RESOURCE[type][index] + ""}
                  onClick={() => checkboxGroup.handleClick(index)}
                  check={checkboxGroup.isSelected(index)}
                />
              ))}
            </Box>
          </Box>
          <Box classes="dropdown-checkbox--bottom">
            <Button
              label={t("common.cancel")}
              type="secondary"
              btnStyle="fill"
              onClick={() => {
                setButtonClick(buttonClick + 1);
                checkboxGroup.handleAllClick(filter[type] ?? []);
              }}
            />
            <Button
              label={t("common.apply")}
              classes="mg ml-10"
              btnStyle="fill"
              onClick={() => {
                setButtonClick(buttonClick + 1);
                changeFilterByKey(type, checkboxGroup.selected);
              }}
            />
          </Box>
        </Box>
      )}
    </Dropdown>
  );
};
export default LogFilterCheckdown;
